<template>
    <div>
      <design-bulletin-check-report-list></design-bulletin-check-report-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  